import { List } from 'immutable';

export function isVisibleTaxDeductionAmount(incomeCode) {
  return [1530, 9991].includes(incomeCode);
}

export function isObjectAmountYearAllowed(year) {
  return year === 2016;
}

export function isDividendsIncome(incomeCode) {
  return incomeCode === 1010;
}

export function isHighClassSpecialistIncome(incomeCode) {
  return [2000, 2001, 2002, 2003, 2004, 2010, 2012, 2013, 2014, 2015, 2300, 2301, 2530].includes(
    incomeCode,
  );
}

export function isOtherIncome(incomeCode) {
  return incomeCode === 4800;
}

export function isIncomeVid01(incomeVidDohod) {
  return incomeVidDohod === '01';
}

export function isIncomeVid10(incomeVidDohod) {
  return incomeVidDohod === '10';
}

export function isIncomeVid16(incomeVidDohod) {
  return incomeVidDohod === '16';
}

export function isIncomeVid19(incomeVidDohod) {
  return incomeVidDohod === '19';
}

export function isIncomeCode(list = [], incomeCode) {
  return list.includes(incomeCode);
}

export function isMaterialAssistanceToEmployeesAtBirth(incomeCode) {
  return incomeCode === 2762;
}

/**
 * Отображается только при выполнении следующих условий:
 поле «Страна, гражданином которой является налогоплательщик (страна, выдавшая документ, удостоверяющий личность)» заполнено и содержит значение, не равное значению «Россия»
 И
 страница «Доходы от источников в Российской Федерации» содержит хотя бы один источник со значением поля «Налоговая ставка» равным «13» и хотя бы одним доходом, вид которого не равен "1010 - Дивиденды"

 * @param citizenship
 * @param sources
 * @returns {boolean}
 */
export function showMigrantCheckBox(citizenship, sources) {
  const has13Income = sources.find(
    (source) =>
      source.get('taxRate') === 13 &&
      source
        .get('incomes', List())
        .find(
          (income) => income.get('incomeTypeCodeASVK') && income.get('incomeTypeCodeASVK') !== 1010,
        ),
  );
  return citizenship !== '643' && has13Income;
}
